import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { Ae2CarouselContainerModule } from '@studios-smart/core/components/carousel-container';
import { Ae2SeoModule } from '@studios-smart/core/directives/seo/seo.module';

@NgModule({
  imports: [
    CommonModule,
    HomeRoutingModule,
    Ae2CarouselContainerModule,
    Ae2SeoModule
  ],
  declarations: [HomeComponent]
})
export class HomeModule { }
